import { httpClient } from '@/domains/core/httpClient/httpClient';
import { getAppSetting } from '@/domains/core/settings/appSettings';
import { getPlatform } from '@/domains/core/settings/utils';

import {
  MS_CATALOG_URL,
  type MsCatalogCategoryResponse,
} from '../../interfaces/msCatalogCategory';

export const fetchMsCatalogCategories = async (
  categoryIds: number[],
): Promise<MsCatalogCategoryResponse> => {
  const url = `${getAppSetting('MS_API_URL')}/api${MS_CATALOG_URL.V3}`;
  const options = {
    params: {
      platform: getPlatform().toUpperCase(),
      category_ids: categoryIds.join(','),
    },
    timeout: Number(getAppSetting('RECOMMENDATION_CATEGORY_TIMEOUT')) || 700,
  };

  const response = await httpClient.get<MsCatalogCategoryResponse>(
    url,
    options,
  );

  return response.data;
};
